import React from "react";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import classNames from "classnames";

import "./index.scss";

type Props = {
  id?: string;
  type?: "text" | "number" | "password";
  name?: string;
  error?: any;
  value?: string;
  label?: string | null;
  leftB_T?: string | null;
  onBlur?: any;
  onClick?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  rightB_T?: string;
  leftIcon?: string;
  isDisable?: boolean;
  rightIcon?: string;
  textAlign?: "right" | "left" | "center";
  errorText?: any;
  inputSize?: "small-input" | "medium-input" | "large-input";
  maxLength?: number;
  minLength?: number;
  isRequired?: boolean;
  inputWidth?: number;
  isPassword?: boolean;
  formikProps?: any;
  placeHolder?: string | null;
  onValueChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  labelTextAlign?: "right" | "left" | "center";
  isShaba?: boolean;
  onClickLeftIcon?: () => void;
};

const userDirection = Cookies.get(constants.USER_DIRECTION);

const CustomInput = ({
  id,
  name,
  type,
  value,
  label,
  error,
  leftB_T,
  onBlur,
  onClick,
  rightB_T,
  leftIcon,
  textAlign = userDirection === "ltr" ? "left" : "right",
  inputSize = "medium-input",
  isDisable,
  errorText,
  maxLength,
  minLength,
  rightIcon,
  inputWidth,
  isRequired,
  isPassword,
  formikProps,
  placeHolder,
  onValueChange,
  labelTextAlign = userDirection === "ltr" ? "left" : "right",
  isShaba,
  onKeyDown,
  onClickLeftIcon,
}: Props) => {
  const [showText, setShowText] = React.useState(false);

  return (
    <section id="custom-input-1-container">
      {label && (
        <div className={classNames("input-label", labelTextAlign)}>
          <label htmlFor={id}>{label}</label>
          {isRequired && <i className={classNames("fa-solid fa-star-of-life", "important-star")}></i>}
        </div>
      )}
      <div className={classNames("input-wrapper", `${inputSize}`)} style={{width: inputWidth}}>
        {rightB_T ? (
          <span className="input-badge" dir="ltr">
            {rightB_T}
          </span>
        ) : null}
        {rightIcon ? <i className={rightIcon}></i> : null}
        {isShaba && <span className="ir-shaba">IR</span>}
        <input
          disabled={isDisable ? true : false}
          id={id}
          onClick={onClick}
          maxLength={maxLength}
          minLength={minLength}
          name={name}
          onBlur={onBlur}
          type={isPassword && showText === false ? "password" : type}
          placeholder={placeHolder}
          readOnly={isDisable ? true : false}
          onChange={onValueChange}
          value={value ? value : ""}
          className={classNames(isDisable ? "disable" : "input-container", textAlign)}
          style={isShaba && {textAlign: "left", paddingLeft: "2.5rem"}}
          onKeyDown={onKeyDown}
          {...formikProps}
        />
        {leftB_T ? <span className="input-badge">{leftB_T}</span> : null}
        {leftIcon ? <i className={leftIcon} onClick={onClickLeftIcon}></i> : null}
        {isPassword && (
          <i className={classNames("fa-solid fa-eye", "password-icon", showText ? "show-password" : null)} onClick={() => setShowText(!showText)}></i>
        )}
      </div>
      {/* {error < p className='error'>{errorText}</>} */}
      {error && <p className="error">{errorText}</p>}
    </section>
  );
};

export default CustomInput;
